import { render, staticRenderFns } from "./AiMailsAdminView.vue?vue&type=template&id=46716291"
import script from "./AiMailsAdminView.vue?vue&type=script&lang=js"
export * from "./AiMailsAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports